module.exports = __webpack_public_path__ + "img/matryoshka.a1fc30d5.svg";